const BASE = process.env.REACT_APP_LOAN_API_ENDPOINT;
const VIACEP_API = process.env.REACT_APP_VIACEP_API_URL;
const LOAN_APPLICATION_API =
    process.env.REACT_APP_LOAN_APPLICATION_API_ENDPOINT;
const CREDIT_ANALYSIS_API = process.env.REACT_APP_CREDIT_ANALYSIS_API_ENDPOINT;
const API_AUTH_TOKEN = process.env.REACT_APP_AUTH;
const GA_ID = process.env.REACT_APP_GA_ID;
const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;
const TRACKER_ENABLED = process.env.REACT_APP_TRACKER_ENABLED === 'true';
const NEURO_ID_ENABLED = process.env.REACT_APP_NEURO_ID_ENABLED === 'true';
const BUGSNAG_KEY = process.env.REACT_APP_BUGSNAG_KEY;
const STAGE = process.env.REACT_APP_STAGE;
const APP_PROFILE: 'default' | 'partners' =
    process.env.REACT_APP_PROFILE === 'partners' ? 'partners' : 'default';
const SITE_URL = process.env.REACT_APP_SITE_URL;
const BIZCONTA_DEEPLINKING = process.env.REACT_APP_BIZCONTA_DEEPLINKING;
const ONBOARDING_DEEPLINKING = process.env.REACT_APP_ONBOARDING_DEEPLINKING;
const SITE_NITEROI_URL = process.env.REACT_APP_SITE_NITEROI_URL;

const endpoint = {
    BASE,
    VIACEP_API,
    LOAN_APPLICATION_API,
    CREDIT_ANALYSIS_API,
    API_AUTH_TOKEN,
};

export {
    endpoint,
    GA_ID,
    PIXEL_ID,
    TRACKER_ENABLED,
    NEURO_ID_ENABLED,
    BUGSNAG_KEY,
    STAGE,
    APP_PROFILE,
    SITE_URL,
    BIZCONTA_DEEPLINKING,
    ONBOARDING_DEEPLINKING,
    SITE_NITEROI_URL,
};
